module.exports = __webpack_public_path__ + "static/homebanking-e1e94b4fabf641e9f57ebddef64247a0.png";